webpackJsonp([419],{

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(2103),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/npm-170.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] npm-170.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28ca0010", Component.options)
  } else {
    hotAPI.reload("data-v-28ca0010", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2103:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("安装使用(webpack)")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("如果你从没使用过 "), _c('code', [_vm._v("VUX")]), _vm._v("，请参考 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/install/biolerplate.html"
    }
  }, [_vm._v("快速入门")]), _vm._v("。"), _c('br'), _c('br'), _vm._v("\n不推荐使用 "), _c('code', [_vm._v("umd")]), _vm._v(" 方式引用组件，但是如果不得不使用，可以参考 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/install/umd.html"
    }
  }, [_vm._v("umd 构建")])], 1)]), _vm._v(" "), _c('p', [_vm._v("直接安装或者更新：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("如果你是从"), _c('code', [_vm._v("0.x")]), _vm._v("更新，请参考： "), _c('router-link', {
    staticStyle: {
      "color": "#42b983"
    },
    attrs: {
      "to": "/zh-CN/install/upgrade-to-vux2.html"
    }
  }, [_vm._v("更新到"), _c('code', [_vm._v("2.x")])])], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vux --save\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("或者使用 "), _c('code', [_vm._v("yarn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn add vux "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 安装")]), _vm._v("\nyarn upgrade vux "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 更新")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果你想直接从 Github 安装，请指定 "), _c('code', [_vm._v("v2")]), _vm._v(" 分支")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install git://github.com/airyland/vux.git"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("#v2")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("vux2必须配合"), _c('code', [_vm._v("vux-loader")]), _vm._v("使用, 请在"), _c('code', [_vm._v("build/webpack.base.conf.js")]), _vm._v("里参照如下代码进行配置：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" vuxLoader = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-loader'")]), _vm._v(")\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" webpackConfig = originalConfig "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 原来的 module.exports 代码赋值给变量 webpackConfig")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = vuxLoader.merge(webpackConfig, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("]\n})\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("vux@0.x 已经停止维护，请尽快迁移到 vue@2.x & vuex@2.x & vux@2.x，虽然要花点时间，但是完全值得。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28ca0010", module.exports)
  }
}

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1751);

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 安装使用 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 419.aed9e88b.js